var _defs, _polygon, _ellipse, _polygon2, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.46 29.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 .1 9.11 .1 6.87 20.19 2.32 20.19 0 .1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 4.55,
    cy: 25.91,
    rx: 3.69,
    ry: 3.73
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.06 .1 25.17 .1 22.93 20.19 18.38 20.19 16.06 .1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 20.62,
    cy: 25.91,
    rx: 3.69,
    ry: 3.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.03,5.57h4.4c2.78,0,4.15,1.55,4.15,4.41v9.03c0,2.85-1.37,4.41-4.15,4.41h-4.4V5.57ZM41.82,8.12v12.76h1.57c.88,0,1.42-.46,1.42-1.74v-9.28c0-1.28-.53-1.74-1.42-1.74h-1.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.64,9.86c0-2.85,1.49-4.47,4.23-4.47s4.22,1.63,4.22,4.47v9.28c0,2.85-1.49,4.47-4.22,4.47s-4.23-1.63-4.23-4.47v-9.28ZM53.43,19.32c0,1.28.56,1.76,1.44,1.76s1.44-.48,1.44-1.76v-9.64c0-1.28-.56-1.76-1.44-1.76s-1.44.48-1.44,1.76v9.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.06,5.57v13.78c0,1.28.56,1.74,1.44,1.74s1.44-.46,1.44-1.74V5.57h2.63v13.6c0,2.85-1.42,4.47-4.15,4.47s-4.15-1.63-4.15-4.47V5.57h2.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.31,9.68v.63c0,1.84-.56,2.99-1.8,3.57v.05c1.49.59,2.07,1.91,2.07,3.8v1.46c0,2.75-1.44,4.23-4.23,4.23h-4.37V5.57h4.2c2.88,0,4.12,1.35,4.12,4.11ZM76.77,8.12v4.72h1.1c1.04,0,1.67-.46,1.67-1.89v-.99c0-1.28-.43-1.84-1.42-1.84h-1.35ZM76.77,15.39v5.49h1.59c.94,0,1.44-.44,1.44-1.76v-1.55c0-1.66-.53-2.17-1.8-2.17h-1.24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.78,5.57h2.78v15.31h4.58v2.54h-7.36V5.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.66,13.1h3.82v2.55h-3.82v5.23h4.8v2.54h-7.59V5.57h7.59v2.55h-4.8v4.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6ccccff6a79a4bff546ac698dc5e6d7b.svg";
export { ForwardRef as ReactComponent };